import { RoutesMap } from '@Router/router.types';
import { useNavigationManager } from '@Router/useNavigationManager';

export const useEmailVerificationNavigationManager = () => {
  const { addNavStackItemAfterSpecificPage, removeNavStackItemByPageName, navigateToNextPage } =
    useNavigationManager();

  const addEmailVerificationToNavStack = (currentPage: RoutesMap) => {
    addNavStackItemAfterSpecificPage(currentPage, RoutesMap.EMAIL_VERIFICATION);
  };

  const removeEmailVerificationFromNavStack = () => {
    removeNavStackItemByPageName(RoutesMap.EMAIL_VERIFICATION);
  };

  return {
    addEmailVerificationToNavStack,
    removeEmailVerificationFromNavStack,
    navigateToNextPage,
  };
};
